module.exports = __webpack_public_path__ + "img/logo-light.f9e286ac.png";